module.exports = __webpack_public_path__ + "img/slide_02_th.6b861b33.jpg";